/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_ExpiredInputs */

const vi_shop_home_expired = /** @type {(inputs: Shop_Home_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã hết lịch`)
};

/**

* @param {Shop_Home_ExpiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_expired = /** @type {((inputs?: Shop_Home_ExpiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_ExpiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_expired(inputs)
});